import Modal from '@advanza/modal'
import { Button, Divider, Icon } from '@advanza/ui'
import AutoRow from 'components/misc/AutoRow'
import RegionsSelect from 'components/regions/RegionsSelect'
import { useState } from 'react'

interface ActionButtonProps {
    name: string
    // Appended to the action URL: ['12', [3, 4]] becomes '/api/office/<action>/12/3,4'
    params: (string | number | number[])[]
    action?: string
}

interface ServiceActionsProps {
    // Comes from the `:id` route param via useParams() in ServiceViewPage, so it is a string
    serviceId: string
}

const actionBtn = ({
    name,
    params,
    action = 'providers/schedule-keywords-task',
}: ActionButtonProps) => {
    return (
        <a target="_blank" href={`/api/office/${action}/${params.join('/')}`} rel="noreferrer">
            <Button>{name}</Button>
        </a>
    )
}

const modalBtn = ({
    name,
    params,
    action = 'providers/schedule-keywords-task',
}: ActionButtonProps) => {
    const [openModal, setOpenModal] = useState<string | false>(false)

    return (
        <>
            <Button onClick={() => setOpenModal(action)}>
                {name} <Icon name="forum" />
            </Button>
            <Modal close={() => setOpenModal(false)} maxWidth={600} open={openModal === action}>
                <div>
                    <h3>{name}</h3>
                    <Divider />
                    <AutoRow>{actionBtn({ name, params, action })}</AutoRow>
                    <Divider />
                </div>
            </Modal>
        </>
    )
}

const setNewImportUntouchedToEnabledModal = ({ serviceId }: ServiceActionsProps) => {
    const [openModal, setOpenModal] = useState<string | false>(false)
    const [selectRegions, setSelectRegions] = useState<number[]>([])

    return (
        <>
            <Button onClick={() => setOpenModal('set-new-import-untouched-to-enabled')}>
                Set new import untouched to enabled <Icon name="forum" />
            </Button>
            <Modal
                close={() => setOpenModal(false)}
                maxWidth={600}
                open={openModal === 'set-new-import-untouched-to-enabled'}>
                <div>
                    <h3>Sets all new_import_untouched profiles to enabled</h3>
                    <Divider />
                    Regions:
                    <RegionsSelect onChangeValue={setSelectRegions} value={selectRegions} />
                    <Divider />
                    <AutoRow>
                        {modalBtn({
                            name: 'Sets all new_import_untouched profiles to enabled',
                            params: [serviceId, selectRegions],
                            action: 'services/set-new-import-untouched-to-enabled',
                        })}
                    </AutoRow>
                    <Divider />
                </div>
            </Modal>
        </>
    )
}

const enablePausedSubscriptionsBtn = ({ serviceId }: ServiceActionsProps) => {
    const [openModal, setOpenModal] = useState<string | false>(false)

    return (
        <>
            <Button onClick={() => setOpenModal('enable-paused-subscriptions')}>
                Enable paused subscriptions <Icon name="forum" />
            </Button>
            <Modal
                close={() => setOpenModal(false)}
                maxWidth={600}
                open={openModal === 'enable-paused-subscriptions'}>
                <div>
                    <h3>Enable paused subscriptions for this service?</h3>
                    <Divider />
                    <AutoRow>
                        {actionBtn({
                            name: 'Enable paused subscriptions',
                            params: [serviceId],
                            action: 'providers/enable-paused-subscriptions',
                        })}
                        {actionBtn({
                            name: 'Enable paused subscriptions (include signed)',
                            params: [serviceId, 1],
                            action: 'providers/enable-paused-subscriptions',
                        })}
                    </AutoRow>
                    <Divider />
                </div>
            </Modal>
        </>
    )
}

const ServiceActions = ({ serviceId }: ServiceActionsProps) => {
    return (
        <div>
            <AutoRow>
                {enablePausedSubscriptionsBtn({ serviceId })}
                {modalBtn({
                    name: 'Export providers with keywords / options',
                    params: [serviceId],
                    action: 'services/export-provider-keywords-options',
                })}
            </AutoRow>

            <Divider m />
            <AutoRow>{setNewImportUntouchedToEnabledModal({ serviceId })}</AutoRow>

            <Divider m />
        </div>
    )
}

export default ServiceActions
